// extracted by mini-css-extract-plugin
export default {"card":"styles_card__ZUNTy","checkbox":"styles_checkbox__tFdgx","screen":"styles_screen__jNepq","done":"styles_done__Es956"};